export default __webpack_public_path__ + "static/media/InstagramSVG.68a9805b.svg";